var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24.4982C5.38297 24.4982 -0.00012207 19.1151 -0.00012207 12.4983C-0.00012207 5.88157 5.38297 0.498474 11.9999 0.498474C18.6168 0.498474 23.9999 5.88156 23.9999 12.4983C23.9999 19.1151 18.6168 24.4982 11.9999 24.4982ZM11.9999 2.4118C6.43804 2.4118 1.9132 6.93663 1.9132 12.4983C1.9132 18.06 6.43804 22.5848 11.9999 22.5848C17.5617 22.5848 22.0866 18.06 22.0866 12.4983C22.0866 6.93663 17.5617 2.4118 11.9999 2.4118Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyRadio);
export default __webpack_public_path__ + "static/media/grey_radio.11ec7a8c90d527e6f4cbdf07c44eea09.svg";
export { ForwardRef as ReactComponent };